import {ObjectWithAttributes, TemplateAttributes} from 'config-migration/MigrationConstants';

import {MigrationStep} from '../../types/MigrationStep';

/**
 * This method returns true if a template is plannable during the current step.
 * We only want to plan Execution templates during the Workflows step / on the Workflow pane.
 * All other templates should only be planned during the Templates step / on the Templates pane.
 *
 * An Execution template has `processTaskSchemaId` in its object attributes while other templates should be
 * grouped by their `templateCollectionId`
 *
 */
export function isTemplatePlannedOnStep(object: ObjectWithAttributes, migrationStep: MigrationStep): boolean {
  if (migrationStep !== MigrationStep.PROCESS_TASK_SCHEMAS && migrationStep !== MigrationStep.TEMPLATES) {
    return false;
  }

  const expectedGrouperAttribute =
    migrationStep === MigrationStep.TEMPLATES ? 'templateCollectionId' : 'processTaskSchemaId';

  return (object.objectAttributes as TemplateAttributes)?.[expectedGrouperAttribute] != null;
}
